import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ShortNumberModule } from "@webapp/shared/pipes/short-number/short-number.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { ProgressIndicatorLabelComponent } from "./progress-indicator-label.component";

@NgModule({
  imports: [CommonModule, UiIconModule, ShortNumberModule],
  declarations: [ProgressIndicatorLabelComponent],
  exports: [ProgressIndicatorLabelComponent],
})
export class ProgressIndicatorLabelModule {}
